import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InspectionService {
  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  GetInspectionList(form) {
    return this.http.post(this.rootUrl + '/api/Inspection/GetInspectionList', form);
  }
  Smtinspectioncall(form) {
    debugger;
    return this.http.post(this.rootUrl + '/api/Inspection/Smtinspectioncall', form);
  }
  GetInspectList(){
    return this.http.get(this.rootUrl + '/api/Inspection/GetInspectList');
  }
  GetPurchaseOrderList(){
    {
      return this.http.get(this.rootUrl + '/api/Inspection/GetPurchaseOrderList');
    }


  }
}
